import styled from "styled-components"


export const ResetMobilePassword = styled.div`
    width: 415px !important;
    padding: 2.5rem;
    display: flex;
    flex-direction: column;
    gap: 30px;
`

export const ResetMobilePasswordHeader = styled.div`
    font-family: var(--SettingsResetMobilePasswordHeaderFont-family);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`

export const ResetMobilePasswordText = styled.div`
  font-size: 16px;
  text-align: center;
`